"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 8,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
function CategoriesConsumer() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div data-section-id="223447" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="flex h-56 flex-col items-center justify-center rounded-lg bg-secondary/20 p-6 animate-pulse border border-border/10">
            <div className="mb-4 h-24 w-24 rounded-md bg-muted/20" />
            <div className="h-6 w-3/4 rounded bg-muted/20" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center rounded-lg bg-secondary/40 backdrop-blur-md border border-border/50 p-8 text-center">
        <p className="mb-4 text-primary font-default">
          An error occurred while loading the game categories.
        </p>
        <button onClick={refetch} className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-2 text-sm font-bold text-primary-foreground transition-all duration-300 hover:bg-primary/80 hover:shadow-[0_0_15px_rgba(37,99,235,0.4)]">
          Retry
        </button>
      </div>;
  }
  if (terms.length === 0) {
    return <div className="text-center text-muted-foreground">
        <p className="font-default">No games found.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {terms.map((term, i) => <div key={term.id} data-index={i} className="h-full">
          <Link to={term.link || "#"} className="group flex h-full flex-col items-center justify-center rounded-lg bg-secondary/40 backdrop-blur-md border border-white/5 p-6 text-center transition-all duration-300 hover:scale-[1.05] hover:bg-secondary/60 hover:shadow-lg hover:shadow-primary/20 hover:border-primary/30">
            {term.image_url ? <div className="mb-4 flex aspect-square w-28 items-center justify-center overflow-hidden rounded-md bg-background/40 p-3 transition-transform duration-300 group-hover:scale-110">
                <img src={term.image_url} alt={term.name} className="h-full w-full object-contain brightness-90 group-hover:brightness-110 group-hover:drop-shadow-[0_0_8px_rgba(37,99,235,0.6)]" loading="lazy" />
              </div> : <div className="mb-4 flex aspect-square w-28 items-center justify-center rounded-md bg-background/40 p-3">
                <span className="text-xs text-muted-foreground font-default">Chưa có ảnh</span>
              </div>}
            <h3 className="font-default text-lg font-bold text-foreground transition-colors group-hover:text-primary tracking-wider uppercase">
              {term.name}
            </h3>
          </Link>
        </div>)}
    </div>;
}
export default function EssentialProductCategories() {
  return;
}